import React from "react";
import { Modal, Button, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

const ConfirmModal = (props) => {
  return (
    <Modal isOpen={props.isOpen}>
      <ModalHeader>{props.title}</ModalHeader>
      <ModalBody>{props.description}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={props.handleClose}>
          Cancel
        </Button>
        <Button color="default" onClick={props.handleConfirm}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
